(function () {
  'use strict';

  var SELECTOR = '.js-cart-tiered-rewards';
  var _prevTier2Reached = null;
  var _prevTier3Reached = null;
  var _giftSyncInFlight = false;

  function getCurrencyRate() {
    try { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; }
    catch (e) { return 1; }
  }

  function formatMoney(cents) {
    try {
      var moneyFormat = window.themeCore.objects.shop.money_format;
      return window.themeCore.utils.formatMoney(cents, moneyFormat);
    } catch (e) {
      return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
    }
  }

  function isGiftLine(item) {
    return !!(item && item.properties && item.properties['_tiered_gift'] === 'tier2');
  }

  function getRealTotal(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (!isGiftLine(item)) total += item.final_line_price;
    });
    return total;
  }

  function fetchCart(callback) {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { callback(cart); })
      .catch(function () { callback(null); });
  }

  function forceFullRefresh() {
    console.log('[Tiered Rewards] Forcing cart drawer refresh...');
    
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.emit('cart:refresh');
      window.themeCore.EventBus.emit('cart:updated');
    }

    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      var wasOpen = drawer.classList.contains('is-active') || drawer.classList.contains('is-open');
      if (wasOpen) {
        drawer.classList.remove('is-active', 'is-open');
        setTimeout(function () {
          drawer.classList.add('is-active', 'is-open');
        }, 100);
      }
    }

    setTimeout(function () {
      fetchCart(function (cart) {
        if (cart) {
          document.querySelectorAll(SELECTOR).forEach(function (root) {
            applyUpdate(root, getRealTotal(cart), false);
          });
        }
      });
    }, 600);
  }

  function syncTier2Gift(root, cart) {
    if (_giftSyncInFlight) return;

    var variantIdRaw = root.getAttribute('data-tier-2-gift-variant-id');
    if (!variantIdRaw) return;
    var variantId = Number(variantIdRaw);
    if (!variantId || !window.themeCore || !window.themeCore.CartApi) return;

    var rate = getCurrencyRate();
    var t2 = Number(root.getAttribute('data-tier-2-cents')) * rate;
    var realTotal = getRealTotal(cart);
    var tier2Reached = realTotal >= t2;

    var giftLine = (cart.items || []).find(function (item) {
      return isGiftLine(item) && item.variant_id === variantId;
    });

    if (tier2Reached && !giftLine) {
      console.log('[Tiered Rewards] Adding free gift (variant ' + variantId + ')...');
      _giftSyncInFlight = true;

      window.themeCore.CartApi.makeRequest(
        window.themeCore.CartApi.actions.ADD_TO_CART,
        { 
          id: variantId, 
          quantity: 1, 
          properties: { '_tiered_gift': 'tier2' } 
        }
      ).then(function () {
        console.log('[Tiered Rewards] ✅ Free gift added successfully');
        setTimeout(forceFullRefresh, 450);
      }).catch(function (err) {
        console.error('[Tiered Rewards] ❌ Add failed:', err);
        if (err && err.message && err.message.includes('sold out')) {
          console.warn('⚠️ Free gift product is out of stock. Enable "Continue selling when out of stock" in Shopify Admin.');
        }
      }).finally(function () {
        _giftSyncInFlight = false;
      });

    } else if (!tier2Reached && giftLine) {
      console.log('[Tiered Rewards] Removing free gift...');
      _giftSyncInFlight = true;

      window.themeCore.CartApi.makeRequest(
        window.themeCore.CartApi.actions.REMOVE_CART_ITEM,
        giftLine.key
      ).then(function () {
        console.log('[Tiered Rewards] ✅ Free gift removed');
        setTimeout(forceFullRefresh, 450);
      }).catch(function (err) {
        console.error('[Tiered Rewards] ❌ Remove failed:', err);
      }).finally(function () {
        _giftSyncInFlight = false;
      });
    }
  }

  function computeProgress(cartTotal, t1, t2, t3) {
    var p1 = 16.667, p2 = 50.000, p3 = 83.333, gap = 2;
    if (cartTotal <= 0) return 0;
    if (cartTotal >= t3) return 100;
    if (cartTotal >= t2) return Math.min(p2 + ((cartTotal - t2) / (t3 - t2)) * (p3 - gap - p2), p3 - gap);
    if (cartTotal >= t1) return Math.min(p1 + ((cartTotal - t1) / (t2 - t1)) * (p2 - gap - p1), p2 - gap);
    return Math.min((cartTotal / t1) * (p1 - gap), p1 - gap);
  }

  function launchConfetti(originEl) {
    // Your original confetti function (unchanged)
    var colors = ['#6D4FE3','#FFD700','#FF6B6B','#4ECDC4','#45B7D1','#96CEB4','#FFEAA7','#DDA0DD'];
    var rect = originEl ? originEl.getBoundingClientRect() : { left: 0, top: 60, width: window.innerWidth, height: 40 };
    var container = document.createElement('div');
    container.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:2147483647;overflow:hidden;';
    document.body.appendChild(container);
    var particles = [];
    for (var i = 0; i < 80; i++) {
      var el = document.createElement('div');
      var size = Math.random() * 9 + 4;
      var color = colors[Math.floor(Math.random() * colors.length)];
      var isRect = Math.random() > 0.4;
      var startX = rect.left + Math.random() * rect.width;
      var startY = rect.top + rect.height;
      el.style.position = 'absolute';
      el.style.width = (isRect ? size : size * 0.5) + 'px';
      el.style.height = size + 'px';
      el.style.background = color;
      el.style.borderRadius = isRect ? '2px' : '50%';
      el.style.left = startX + 'px';
      el.style.top = startY + 'px';
      container.appendChild(el);
      var angle = (Math.random() * 120 - 60) * (Math.PI / 180);
      var speed = Math.random() * 8 + 4;
      particles.push({ el: el, x: startX, y: startY, vx: Math.sin(angle) * speed, vy: Math.cos(angle) * speed, rot: Math.random() * 360, rotV: (Math.random() - 0.5) * 10, gravity: 0.15 + Math.random() * 0.15, life: 1 });
    }
    function frame() {
      var alive = false;
      particles.forEach(function (p) {
        if (p.life <= 0) return;
        p.x += p.vx; p.vx *= 0.99;
        p.y += p.vy; p.vy += p.gravity;
        p.rot += p.rotV;
        p.life -= 0.012;
        if (p.life > 0) {
          alive = true;
          p.el.style.left = p.x + 'px';
          p.el.style.top = p.y + 'px';
          p.el.style.opacity = Math.max(0, p.life);
          p.el.style.transform = 'rotate(' + p.rot + 'deg)';
        } else {
          p.el.style.opacity = 0;
        }
      });
      if (alive) requestAnimationFrame(frame);
      else if (container.parentNode) container.parentNode.removeChild(container);
    }
    requestAnimationFrame(frame);
  }

  function applyUpdate(root, cartTotal, fireConfetti) {
    var rate = getCurrencyRate();
    root.setAttribute('data-cart-total', cartTotal);
    var tierCents = [1, 2, 3].map(function (n) {
      return Number(root.getAttribute('data-tier-' + n + '-cents')) * rate;
    });
    var t1 = tierCents[0], t2 = tierCents[1], t3 = tierCents[2];
    var tier2ProductImage = root.getAttribute('data-tier-2-product-image') || '';
    var tier2Reached = cartTotal >= t2;
    var tier3Reached = cartTotal >= t3;

    var pct = computeProgress(cartTotal, t1, t2, t3);
    root.style.setProperty('--tiered-bar-progress-value', pct.toFixed(3) + '%');

    var stops = root.querySelectorAll('.js-cart-tiered-rewards-stop');
    var currentTierIndex = -1;
    stops.forEach(function (stop, i) {
      var reached = cartTotal >= tierCents[i];
      stop.classList.toggle('is-reached', reached);
      if (!reached && currentTierIndex === -1) currentTierIndex = i;
      stop.classList.toggle('is-current', i === currentTierIndex);
    });

    if (fireConfetti) {
      var headingEl = document.querySelector('#CartDrawer .drawer__header, #CartDrawer .cart-drawer__heading');
      if (tier2Reached && _prevTier2Reached === false) launchConfetti(headingEl);
      if (tier3Reached && _prevTier3Reached === false) {
        var delay = (tier2Reached && _prevTier2Reached === false) ? 700 : 0;
        setTimeout(function () { launchConfetti(headingEl); }, delay);
      }
      _prevTier2Reached = tier2Reached;
      _prevTier3Reached = tier3Reached;
    }

    var messageEl = root.querySelector('.js-cart-tiered-rewards-message');
    var messageTextEl = root.querySelector('.js-cart-tiered-rewards-message-text');
    var messageIconEl = root.querySelector('.js-cart-tiered-rewards-message-icon');
    var messageLockEl = root.querySelector('.js-cart-tiered-rewards-message-lock');
    if (!messageEl || !messageTextEl) return;

    if (currentTierIndex === -1) {
      var completeMsg = root.getAttribute('data-tier-3-complete-message') || 'All rewards unlocked!';
      messageEl.classList.add('is-complete');
      if (messageIconEl) messageIconEl.textContent = '🎉';
      if (messageLockEl) messageLockEl.style.display = 'none';
      messageTextEl.innerHTML = completeMsg;
    } else {
      var remaining = Math.max(0, tierCents[currentTierIndex] - cartTotal);
      var remainingFormatted = formatMoney(remaining);
      var rawMsg = root.getAttribute('data-tier-' + (currentTierIndex + 1) + '-message') || '';
      var msg = rawMsg.replace('{amount}', '<strong>' + remainingFormatted + '</strong>');
      messageEl.classList.remove('is-complete');
      if (messageLockEl) messageLockEl.style.display = '';
      if (messageIconEl && currentTierIndex === 1 && tier2ProductImage) {
        messageIconEl.innerHTML = '<img src="' + tier2ProductImage + '" alt="" width="28" height="28" loading="eager" />';
        messageIconEl.classList.add('cart-tiered-rewards__message-icon--image');
      }
      messageTextEl.innerHTML = msg;
    }
  }

  function updateAll() {
    var roots = document.querySelectorAll(SELECTOR);
    if (!roots.length) return;

    fetchCart(function (cart) {
      if (!cart) return;
      var realTotal = getRealTotal(cart);

      roots.forEach(function (root) {
        if (_prevTier2Reached === null || _prevTier3Reached === null) {
          var rate = getCurrencyRate();
          var t2 = Number(root.getAttribute('data-tier-2-cents')) * rate;
          var t3 = Number(root.getAttribute('data-tier-3-cents')) * rate;
          _prevTier2Reached = realTotal >= t2;
          _prevTier3Reached = realTotal >= t3;
        }
        applyUpdate(root, realTotal, true);
        syncTier2Gift(root, cart);
      });
    });
  }

  function updateAllDeferred() {
    requestAnimationFrame(function () { requestAnimationFrame(updateAll); });
  }

  window.CartTieredRewardsUpdate = updateAll;

  function watchDrawerOpen() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var wasOpen = false;
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('is-active') ||
                   drawer.classList.contains('is-open') ||
                   drawer.getAttribute('aria-hidden') === 'false';
      if (isOpen && !wasOpen) {
        setTimeout(updateAll, 100);
        setTimeout(updateAll, 450);
      }
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true });
  }

  function attachEventBusListeners() {
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.listen('cart:updated', updateAllDeferred);
      window.themeCore.EventBus.listen('cart:refresh', updateAllDeferred);
      return true;
    }
    return false;
  }

  function fallbackInit() {
    watchDrawerOpen();
    if (!attachEventBusListeners()) {
      var attempts = 0;
      var retry = setInterval(function () {
        attempts++;
        if (attachEventBusListeners() || attempts > 20) clearInterval(retry);
      }, 250);
    }
    setTimeout(updateAll, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fallbackInit, { once: true });
  } else {
    fallbackInit();
  }
})();